import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OrderShareModalButton from '../../components/OrderShareModalButton';

import {
  trackClickedShareTracker,
  trackCopiedShareTrackerLink,
} from '../../actions/tracking/orderStatusSharing';
import { requestOrderStatusShare } from '../../actions/orderActions';
import { isFeatureActive } from '../../selectors/configSelectors';
import { CX_SHAREABLE_ORDER_STATUS, CX_SHARING_TOKENS } from '../../flags/features';

export const OrderShareModalButtonContainer = ({
  shareableOrderStatusFeatureOn,
  allowedToCreateSharingFeatureOn,
  showShareOrderTrackerLink,
  sharingToken,
  sharingShortUrl,
  onRequestOrderStatusShare,
  onClickedShareTracker,
  onCopiedShareTrackerLink,
  mobileView,
  loading,
  error,
}) =>
  shareableOrderStatusFeatureOn &&
  allowedToCreateSharingFeatureOn &&
  showShareOrderTrackerLink && (
    <OrderShareModalButton
      loading={loading}
      error={error}
      sharingToken={sharingToken}
      sharingShortUrl={sharingShortUrl}
      requestOrderStatusShare={onRequestOrderStatusShare}
      onClickedShareTracker={onClickedShareTracker}
      onCopiedShareTrackerLink={onCopiedShareTrackerLink}
      mobileView={mobileView}
    />
  );

OrderShareModalButtonContainer.propTypes = {
  sharingToken: PropTypes.string,
  sharingShortUrl: PropTypes.string,
  onRequestOrderStatusShare: PropTypes.func.isRequired,
  onClickedShareTracker: PropTypes.func.isRequired,
  onCopiedShareTrackerLink: PropTypes.func.isRequired,
  shareableOrderStatusFeatureOn: PropTypes.bool,
  allowedToCreateSharingFeatureOn: PropTypes.bool,
  showShareOrderTrackerLink: PropTypes.bool,
};

OrderShareModalButtonContainer.defaultProps = {
  shareableOrderStatusFeatureOn: false,
  allowedToCreateSharingFeatureOn: false,
  showShareOrderTrackerLink: false,
  mobileView: false,
  loading: false,
};

const mapStateToProps = (state) => {
  const order = state.order;
  const shareModal = order && order.status && order.status.shareModal;
  const orderAttributes = order && order.status && order.status.attributes;

  return {
    error: shareModal && shareModal.error,
    loading: shareModal && shareModal.loading,
    sharingToken: shareModal && shareModal.sharingToken,
    sharingShortUrl: shareModal && shareModal.sharingShortUrl,
    showShareOrderTrackerLink: Boolean(
      orderAttributes && orderAttributes.showShareOrderTrackerLink,
    ),
    // Feature flag: Show option to share order status
    shareableOrderStatusFeatureOn: isFeatureActive(state, CX_SHAREABLE_ORDER_STATUS),
    // Feature flag: Can create a sharing link
    allowedToCreateSharingFeatureOn: isFeatureActive(state, CX_SHARING_TOKENS),
  };
};

const mapActionsToProps = (dispatch) => ({
  onClickedShareTracker: () => dispatch(trackClickedShareTracker()),
  onCopiedShareTrackerLink: () => dispatch(trackCopiedShareTrackerLink()),
  onRequestOrderStatusShare: () => dispatch(requestOrderStatusShare()),
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(OrderShareModalButtonContainer);
